<template>
  <div
    id="artist"
    class="dd-container container"
    @contextmenu="handlePaste($event)"
  >
    <div class="left">
      <p class="name">{{detail.name}}</p>

      <p class="nationality">
        <span v-if="detail.birth">{{detail.birth}}</span>
        <span
          class="vline"
          v-if="detail.birth"
        >|</span>
        <span>{{detail.nationality}}</span>
      </p>

      <div class="intro-wrap">
        <div
          ref="intro"
          class="intro"
          :class="{'intro-expand': isShowExpandIntro && expandIntro}"
          v-html="detail.briefIntroduction"
        ></div>

        <van-divider
          v-if="detail.briefIntroduction"
          @click="handleExpandIntro"
          :hairline="false"
          :style="{ width: '100%', color: '#5e5e5e', borderColor: '#e5e5e5', cursor: 'pointer' }"
        >
          <svg
            v-if="isShowExpandIntro && expandIntro"
            class="icon button-prev"
            aria-hidden="true"
          >
            <use xlink:href="#icon-shang"></use>
          </svg>
          <svg
            v-else-if="isShowExpandIntro && !expandIntro"
            class="icon button-prev"
            aria-hidden="true"
          >
            <use xlink:href="#icon-xia"></use>
          </svg>
        </van-divider>
      </div>

      <div class="exhibit-wrap">
        <div
          ref="exhibit"
          v-html="detail.exhibit"
          class="exhibit"
          :class="{'exhibit-expand': isShowExpandExhibit && expandExhibit}"
        >
        </div>

        <van-divider
          v-if="detail.exhibit"
          @click="handleExpandExhibit"
          :hairline="false"
          :style="{ width: '100%', color: '#5e5e5e', borderColor: '#e5e5e5', cursor: 'pointer' }"
        >
          <svg
            v-if="isShowExpandExhibit && expandExhibit"
            class="icon"
            aria-hidden="true"
          >
            <use xlink:href="#icon-shang"></use>
          </svg>
          <svg
            v-else-if="isShowExpandExhibit && !expandExhibit"
            class="icon"
            aria-hidden="true"
          >
            <use xlink:href="#icon-xia"></use>
          </svg>
        </van-divider>
      </div>
    </div>

    <div
      class="right"
      v-if="detail.items && detail.items.length"
    >
      <div>
        <img
          class="opus-img"
          :src="opusImg"
        >
      </div>

      <nuxt-link
        class="details"
        target="_blank"
        :to="localePath('/artists/opus/' + detail.id)"
      ><span style="height: 24px; display: block;">{{$t('details')}}</span>
        <p style="font-size: 24px; color: #5e5e5e; height: 24px;">
          <svg
            class="icon"
            aria-hidden="true"
          >
            <use xlink:href="#icon-you"></use>
          </svg>
        </p>
      </nuxt-link>
    </div>
  </div>
  </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Divider } from 'vant'

export default {
  data () {
    return {
      isShowExpandIntro: false,
      expandIntro: false,
      isShowExpandExhibit: false,
      expandExhibit: false
    }
  },

  computed: {
    ...mapState('artist', ['detail']),
    opusImg () {
      if (!(this.detail.items && this.detail.items.length)) {
        return ''
      }

      const topArr = this.detail.items.filter(item => parseInt(item.top) === 0)
      if (topArr && topArr.length) {
        return topArr[0].img
      }

      return this.detail.items[0].img
    }
  },

  components: {
    [Divider.name]: Divider
  },

  async fetch ({ store, app, params }) {
    await store.dispatch('artist/getDetail', {
      id: params.id,
      app
    })
  },

  mounted () {
    this.$nextTick(() => {
      const introDom = this.$refs.intro
      if (introDom) {
        const introDomH = introDom.offsetHeight || 0
        this.isShowExpandIntro = introDomH >= 110
      }

      const exhibitDom = this.$refs.exhibit
      if (exhibitDom) {
        const exhibitDomH = exhibitDom.offsetHeight || 0
        this.isShowExpandExhibit = exhibitDomH >= 250
      }
    })
  },

  methods: {
    handleExpandIntro () {
      this.expandIntro = !this.expandIntro
    },

    handleExpandExhibit () {
      this.expandExhibit = !this.expandExhibit
    },

    handlePaste (event) {
      // 禁用鼠标右键
      event.preventDefault()
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding-top: 77px;
  padding-bottom: 67px;

  .left {
    width: 642px;

    .name {
      margin-bottom: 20px;
      color: #000000;
      font-weight: bold;
      font-size: 28px;

      @include clamps-text-overflow(3);
    }

    .nationality {
      display: flex;
      align-items: center;
      margin-bottom: 60px;
      color: #5e5e5e;
      font-size: 14px;

      @include clamps-text-overflow(1);

      .vline {
        margin: 0 4px;
      }
    }

    .intro-wrap {
      .intro {
        overflow: hidden;
        margin-bottom: 24px;
        max-height: 110px;

        @include clamps-text-overflow(4);

        &.intro-expand {
          overflow: auto;
          max-height: inherit;

          @include clamps-text-overflow-reset();
        }
      }
    }

    .exhibit-wrap {
      .exhibit {
        overflow: hidden;
        margin-top: 24px;
        margin-bottom: 24px;
        max-height: 250px;

        @include clamps-text-overflow(12);

        &.exhibit-expand {
          overflow: auto;
          max-height: inherit;

          @include clamps-text-overflow-reset();
        }
      }
    }

    ::v-deep {
      .van-divider::before,
      .van-divider::after {
        border-width: 1px 0 0;
      }

      .icon {
        color: #5e5e5e;
        font-size: 24px;
      }
    }
  }

  .right {
    display: flex;
    align-items: flex-end;
    flex-direction: column;

    .opus-img {
      margin-bottom: 18px;
      width: 416px;
      height: 514px;

      object-fit: scale-down;
    }

    .details {
      display: flex;
      align-items: baseline;
      color: #000000;
      font-size: 16px;
      line-height: 24px;

      span {
        margin-right: 20px;
      }
    }
  }
}
</style>

<style lang="scss">
#artist.container .intro,
#artist.container .exhibit {
  font-size: 14px;
  line-height: 24px;

  button,
  textarea,
  input,
  object,
  select {
    display: inline-block;
  }
  ol,
  ul,
  dir,
  menu,
  dd {
    margin-left: 40px;
  }
  i,
  cite,
  em,
  var,
  address {
    font-style: italic;
  }

  html,
  body,
  div,
  ol,
  p,
  ul,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  address,
  blockquote,
  form,
  dd,
  dl,
  dt,
  fieldset,
  frame,
  frameset,
  center,
  dir,
  hr,
  menu,
  pre {
    display: block;
  }

  li {
    display: list-item;
  }
  ul {
    display: block;
    padding-left: 40px;
    list-style-type: disc;

    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
  }
  ol {
    display: block;
    padding-left: 40px;
    list-style: decimal;

    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
  }
  ol ul,
  ul ol,
  ul ul,
  ol ol {
    margin-top: 0;
    margin-bottom: 0;
  }

  h1 {
    margin: 0.67em 0;
    font-size: 2em;
  }
  h2 {
    margin: 0.75em 0;
    font-size: 1.5em;
  }
  h3 {
    margin: 0.83em 0;
    font-size: 1.17em;
  }
  h4,
  p,
  blockquote,
  ul,
  fieldset,
  form,
  ol,
  dl,
  dir,
  menu {
    margin: 1em 0;
    line-height: 24px;
  }
  h5 {
    margin: 1.5em 0;
    font-size: 0.83em;
  }
  h6 {
    margin: 1.67em 0;
    font-size: 0.75em;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  b,
  strong {
    font-weight: bolder;
  }

  a,
  a:focus,
  a:hover {
    color: rgb(32, 36, 40);
    text-decoration: underline;
  }

  br:before {
    content: ”\A”;
  }
  :before,
  :after {
    white-space: pre-line;
  }
  :link,
  :visited {
    text-decoration: underline;
  }
  :focus {
    outline: thin dotted invert;
  }

  table {
    display: table;
    border: 1px solid #000;
    border-spacing: 2px;
    border-collapse: separate;
  }
  tr {
    display: table-row;
    border: inherit;
  }
  thead {
    display: table-header-group;
    border: inherit;
  }
  tbody {
    display: table-row-group;
  }
  tfoot {
    display: table-footer-group;
  }
  col {
    display: table-column;
  }
  colgroup {
    display: table-column-group;
  }
  td,
  th {
    display: table-cell;
    border: 1px solid #000;
    vertical-align: inherit;
  }
  caption {
    display: table-caption;
    text-align: center;
  }
  th {
    text-align: center;
    font-weight: bolder;
  }
  thead,
  tbody,
  tfoot {
    vertical-align: middle;
  }

  blockquote {
    margin-right: 40px;
    margin-left: 40px;
  }
  pre,
  tt,
  code,
  kbd,
  samp {
    font-family: monospace;
  }
  pre {
    white-space: pre;
  }
  big {
    font-size: 1.17em;
  }
  small,
  sub,
  sup {
    font-size: 0.83em;
  }
  sub {
    vertical-align: sub;
  }
  sup {
    vertical-align: super;
  }
  s,
  strike,
  del {
    text-decoration: line-through;
  }
  hr {
    border: 1px inset;
  }
  u,
  ins {
    text-decoration: underline;
  }
  center {
    text-align: center;
  }
  abbr,
  acronym {
    letter-spacing: 0.1em;
    font-variant: small-caps;
  }

  bdo[DIR='ltr'] {
    unicode-bidi: bidi-override;
    direction: ltr;
  }
  bdo[DIR='rtl'] {
    unicode-bidi: bidi-override;
    direction: rtl;
  }
  /*定义BDO元素当其属性为DIR="ltr/rtl"时的默认文本读写显示顺序*/
  *[DIR='ltr'] {
    unicode-bidi: embed;
    direction: ltr;
  }
  *[DIR='rtl'] {
    unicode-bidi: embed;
    direction: rtl;
  }
  /*定义任何元素当其属性为DIR="rtl/rtl"时的默认文本读写显示顺序*/
  @media print {
    h1 {
      page-break-before: always;
    }
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      page-break-after: avoid;
    }
    ul,
    ol,
    dl {
      page-break-before: avoid;
    }
  } /*定义标题和列表默认的打印样式*/

  img {
    width: 100%;

    object-fit: contain;
  }
}
</style>
